/* 
*  Created by SGiri 07/12/2018
*/

import { Component, OnInit } from '@angular/core';
import { Constants } from '~util/app.constant';
import { SearchService } from '~config/services/search.service';
import { AppUtil } from '~util/app.util';
import { FormGroup, FormControl } from '@angular/forms';
import { GridOptions } from 'ag-grid';
import { CognosService } from '~cognos/service/cognos.service';

@Component({
  selector: 'app-cognos-search',
  templateUrl: './cognos-search.component.html',
  styleUrls: ['./cognos-search.component.css']
})
export class CognosSearchComponent implements OnInit {

  form : FormGroup;
  gridOptions: GridOptions;
  columnDefs: any[]
  rowData: any[];
  style: {};
  folders: any[];

  constructor(private util: AppUtil, private service: CognosService) { }

  ngOnInit() {
    this.gridOptions = this.util.getGridOptions('No data to display. Please provide valid search param');
    this.columnDefs = this.getColumnDef();
    this.style = Constants.gridStyle;
    this.rowData = [];

    this.folders = this.service.getSearchFolders();

    this.form = new FormGroup({
      folder: new FormControl('Public Folders'),
      searchParam: new FormControl(),
    })
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  getRowData(search: any) {

    let request = {
      searchParam: search.searchParam,
      folders: [search.folder]
    }

    this.service.getCognosSearchData(request).subscribe((data: any[]) => {
      this.rowData = data;
    });
  }

  getColumnDef() {
    return [
      { headerName: "#", valueGetter: this.getIndex, width: 50 },
      { headerName: "Report Name", field: "name" },
      { headerName: "Location", field: "location" },
      { headerName: "Package", field: "cognosPackage" }
    ];
  }

  search() {

    if (!this.form.controls.searchParam.value || this.form.controls.searchParam.value.length < 2) {
      this.form.controls.searchParam.setErrors({ required: true });
      return;
    }

    let search = this.form.value;

    this.gridOptions.api.showLoadingOverlay();
    this.getRowData(search);
  }

  getIndex(params) {
    return Number.parseInt(params.node.id) + 1;
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/cognos/cognos-search/cognos-search.component.ts